module.exports = __webpack_public_path__ + "img/virtual_kit.778c9ce7.png";